import React from 'react';

import { Icon } from '@chakra-ui/react';

export const DataGroupIcon = props => (
  <Icon viewBox="0 0 720 721" color="inherit" h="full" w="full" {...props}>
    <g transform="translate(-388 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M830.956 94.6906C830.956 50.069 731.803 13.9271 609.496 13.9271 487.181 13.9271 388.035 50.069 388.035 94.6906L388.035 160.95C388.035 205.556 487.181 241.698 609.496 241.698 617.852 241.698 626.085 241.521 634.203 241.182 638.505 183.572 729.156 149.638 830.956 141.305L830.956 94.6906Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M388.004 205.54 388.035 211.519 388.035 314.982C388.035 359.596 487.181 395.738 609.496 395.738 617.76 395.738 625.924 395.568 633.965 395.238L633.965 279.802C625.924 280.125 617.767 280.31 609.496 280.31 492.706 280.317 396.422 247.338 388.004 205.54Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M388.081 361.435 388.035 367.421 388.035 470.892C388.035 515.482 487.181 551.624 609.496 551.624 617.76 551.624 625.924 551.448 633.965 551.132L633.965 465.736 633.965 435.696C625.924 436.042 617.767 436.204 609.496 436.204 492.706 436.204 396.491 403.225 388.081 361.435Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M886.535 170.368C764.228 170.368 665.059 206.51 665.059 251.108L665.059 317.375C665.059 361.989 764.228 398.123 886.535 398.123 1008.84 398.123 1108 361.996 1108 317.375L1108 251.108C1108 206.51 1008.84 170.368 886.535 170.368Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M886.535 436.743C769.761 436.743 673.546 403.779 665.136 361.958L665.059 367.937 665.059 471.384C665.059 516.006 764.228 552.14 886.535 552.14 1008.84 552.14 1108 516.013 1108 471.392L1108 367.944C1108 365.921 1107.57 363.959 1107.17 361.966 1098.74 403.779 1003.31 436.743 886.535 436.743Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
              <path
                d="M886.535 592.637C769.761 592.637 673.623 559.658 665.205 517.875L665.051 523.831 665.051 627.294C665.051 671.923 764.228 708.057 886.528 708.057 1008.83 708.057 1107.99 671.923 1107.99 627.294L1107.99 523.839C1107.99 521.831 1107.56 519.83 1107.17 517.883 1098.74 559.65 1003.31 592.637 886.535 592.637Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
